/**
 * A stand-in thumbnail for demo content.
 *
 * Real articles carry their own image from the catalogue. Sample content has
 * none, and an article row without a thumbnail reads as broken rather than as
 * sample data — so each category gets a recognisable tinted mark. Inline SVG
 * keeps it offline: no network, no broken-image icon, and it survives in an
 * email preview where a remote placeholder service would not.
 */
const TINTS: Record<string, [string, string]> = {
  Nutrition: ["#DCFCE7", "#16A34A"],
  Pregnancy: ["#FCE7F3", "#DB2777"],
  Diabetes: ["#DBEAFE", "#2563EB"],
  "Heart health": ["#FEE2E2", "#DC2626"],
  "Mental health": ["#EDE9FE", "#7C3AED"],
  Skin: ["#FFEDD5", "#EA580C"],
  "Women's health": ["#FCE7F3", "#BE185D"],
  "Children's health": ["#E0F2FE", "#0284C7"],
  "Weight loss": ["#CCFBF1", "#0D9488"],
};

export function articleThumb(category?: string, seed = 0): string {
  const [bg, fg] = TINTS[category ?? ""] ?? ["#E9EFFB", "#155EEF"];
  // A few simple arrangements so a column of rows is not visually identical.
  const shapes = [
    `<circle cx="96" cy="54" r="26" fill="${fg}" opacity=".85"/><rect x="60" y="92" width="72" height="10" rx="5" fill="${fg}" opacity=".45"/>`,
    `<rect x="56" y="28" width="80" height="44" rx="10" fill="${fg}" opacity=".8"/><rect x="56" y="84" width="48" height="10" rx="5" fill="${fg}" opacity=".45"/>`,
    `<path d="M40 100 L78 52 L104 80 L136 40 L136 104 L40 104 Z" fill="${fg}" opacity=".8"/>`,
    `<circle cx="72" cy="52" r="20" fill="${fg}" opacity=".8"/><circle cx="116" cy="70" r="28" fill="${fg}" opacity=".5"/>`,
  ];
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="192" height="128" viewBox="0 0 192 128">` +
    `<rect width="192" height="128" fill="${bg}"/>${shapes[seed % shapes.length]}</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
